module.exports = __webpack_public_path__ + "static/media/clinician-watchman-device-800w.73112e68.webp";